import { useGetCurrentTenantQuery } from 'store/api/tenants';
import { Setting } from 'types/back-office-settings';
import { t } from 'utils/getTranslations';
import { useSettings } from 'utils/useSettings';

/**
 * The Administrator/Assistant field of the case and contact forms: whether ADMINISTRATOR_FIELD is on for the signed-in
 * colleague, and the field's name and labels as the firm names it. The name reads "assistant" while the firm has none
 * and while the tenant loads.
 */
export const useAdministratorField = () => {
    const isOn = useSettings().isSettingEnabled(Setting.ADMINISTRATOR_FIELD);
    const { data: tenant } = useGetCurrentTenantQuery(undefined, { skip: !isOn });
    const name = tenant?.administratorFieldName || t('back-office-settings.ADMINISTRATOR_FIELD.default-name');
    return {
        isOn,
        name,
        caseLabel: t('matters.case-assistant', { name }),
        clientLabel: t('contacts.about.client-assistant', { name }),
    };
};
